module.exports = __webpack_public_path__ + "static/media/logo_stream_servers.9fd2aebf.png";